import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { SortOption } from "@/utils/profileUtils";
import { Home } from "lucide-react";
import UnifiedHeader from "@/components/layout/UnifiedHeader";
import { useCurrentNavItem } from "@/hooks/useCurrentNavItem";
import React from "react";

interface FeedHeaderProps {
  sortBy: SortOption;
  onSortChange: (value: SortOption) => void;
  children?: React.ReactNode;
}

const FeedHeader = ({
  sortBy,
  onSortChange,
  children
}: FeedHeaderProps) => {
  const currentNavItem = useCurrentNavItem();
  const Icon = currentNavItem?.icon || Home;
  const rightContent = (
    <div className="flex items-center gap-2">
      {children}
      <Select value={sortBy} onValueChange={value => onSortChange(value as SortOption)}>
        <SelectTrigger className="bg-black/40 border-white/20 text-white w-[140px] h-8 text-xs">
          <SelectValue placeholder="Ordenar" />
        </SelectTrigger>
        <SelectContent className="bg-black/90 border-white/20 text-white w-[140px] md:max-w-[180px]" align="end" sideOffset={8}>
          <SelectItem value="recent">Recentes</SelectItem>
          <SelectItem value="distance">Próximos</SelectItem>
          <SelectItem value="new">Novos</SelectItem>
          <SelectItem value="verified">Verificados</SelectItem>
          <SelectItem value="online">Online</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
  return <UnifiedHeader title={currentNavItem?.label || "Feed"} subtitle={currentNavItem?.description || "Conexões Autênticas"} icon={Icon} iconColor="text-white" iconBgColor="bg-luxury-pinkBright border-luxury-pinkBright" rightContent={rightContent} className="!left-0" />;
};

export default FeedHeader;